export default "__VITE_ASSET__Bb2fK297__"